import {
  SUPERSET_CHAUFFEUR_LEADERBOARD,
  SUPERSET_CHAUFFEUR_LEADERBOARD_SUCCESS,
  SUPERSET_CHAUFFEUR_LEADERBOARD_ERROR,
  SUPERSET_CHAUFFEUR_LEADERBOARD_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetChauffeurLeaderboard = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_CHAUFFEUR_LEADERBOARD:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CHAUFFEUR_LEADERBOARD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CHAUFFEUR_LEADERBOARD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_CHAUFFEUR_LEADERBOARD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetChauffeurLeaderboard;
